/**
 * Prefetch lazy-loaded modal and context menu chunks
 * Call this after the app is ready to load commonly-used UI components in the background
 */
export async function prefetchModalChunks() {
    if (typeof requestIdleCallback === 'undefined') {
        // Fallback for browsers without requestIdleCallback
        setTimeout(prefetchModals, 2000);
    } else {
        requestIdleCallback(prefetchModals, { timeout: 5000 });
    }
}

async function prefetchModals() {
    try {
        // Import all modal components to trigger chunk loading
        // These are used frequently and benefit from prefetching
        await Promise.all([
            import('../ui/screens/modals/CreateWorkspace/CreateWorkspace').then(m => m.CreateWorkspace),
            import('../ui/screens/modals/Invite/Invite').then(m => m.Invite),
            import('../ui/screens/modals/components/UserDeleteModal').then(m => m.UserDeleteModal),
            import('../ui/screens/modals/UnsavedChangesConfirm/UnsavedChangesConfirm').then(m => m.UnsavedChangesConfirm),
            import('../ui/screens/modals/DocumentViewModal/DocumentViewModal').then(m => m.DocumentViewModal),
        ]);

        // Prefetch editor toolbars
        await Promise.all([
            import('../ui/elements/context-menu/editor/TextToolbar/TextToolbar').then(m => m.TextToolbar),
            import('../ui/elements/context-menu/editor/TriggerToolbar/TriggerToolbar').then(m => m.TriggerToolbar),
            import('../ui/elements/context-menu/editor/TableToolbar/TableToolbar').then(m => m.TableToolbar),
            import('../ui/elements/context-menu/editor/ImageToolbar/ImageToolbar').then(m => m.ImageToolbar),
            import('../ui/elements/context-menu/editor/EmbedToolbar/EmbedToolbar').then(m => m.EmbedToolbar),
            import('../ui/elements/context-menu/editor/CalloutToolbar/CalloutToolbar').then(m => m.CalloutToolbar),
            import('../ui/elements/context-menu/editor/LinkInContextEditBar/LinkInContextEditBar').then(m => m.LinkInContextEditBar),
            import('../ui/elements/context-menu/editor/PlusToolbar/PlusToolbar').then(m => m.PlusToolbar),
        ]);
    } catch (err) {
        // Silently ignore prefetch errors - these are non-critical background loads
        console.debug('Prefetch chunks completed', err);
    }
}
